webpackJsonp([12],{

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(595),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ab98fc2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['edit', 'maxViewId', 'orderTypes', 'selectedOrderTypes'],
  data: function data() {
    return {
      err: '',
      language: this.$cookie.get('lang') || 'en',
      languages: JSON.parse(localStorage.languages),
      view: {
        names: [{
          language: this.$cookie.get('lang') || 'en',
          name: ''
        }],
        isDefault: false,
        orderTypes: []
      },
      isEdit: false
    };
  },

  methods: {
    addLang: function addLang(lang, langIndex) {
      this.view.names.push({
        language: lang,
        name: ''
      });
      this.languages.splice(langIndex, 1);
    },
    submit: function submit() {
      var view = {};
      if (!this.isEdit) {
        view['viewId'] = this.maxViewId + 1;
      } else {
        view['viewId'] = this.edit.view.viewId;
      }
      view.name = {};
      this.view.names.forEach(function (entry) {
        if (entry.name !== '') {
          view.name[entry.language] = entry.name;
        }
      });
      view.isDefault = this.view.isDefault;
      view.orderTypes = this.view.orderTypes;
      if (this.isEdit) {
        var index = this.edit.index;
        this.$emit('update', {
          view: view,
          index: index
        });
      } else {
        this.$emit('submit', view);
      }
      this.$emit('close');
    }
  },
  created: function created() {
    var _this = this;

    if (this.edit) {
      this.isEdit = true;
      var view = this.edit.view;
      var languages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(view.name);
      this.view.names = [];
      this.view.isDefault = view.isDefault;
      this.view.orderTypes = view.orderTypes || [];
      languages.forEach(function (language) {
        var index = null;
        _this.view.names.push({
          language: language,
          name: view.name[language]
        });
        _this.languages.forEach(function (lang, i) {
          if (lang.value === language) {
            index = i;
          }
        });
        if (index !== null) {
          _this.languages.splice(index, 1);
        }
      });
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".err[data-v-ab98fc2e]{font-size:16px;padding:15px;padding-top:0}.modal[data-v-ab98fc2e]{display:block;background:rgba(0,0,0,.5)}.modal-body[data-v-ab98fc2e]{max-height:80vh;overflow-y:auto}@media (min-width:576px){.modal-dialog[data-v-ab98fc2e]{max-width:70%}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/ViewsModal.vue"],"names":[],"mappings":"AACA,sBACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AACD,wBACE,cAAe,AACf,yBAA+B,CAChC,AACD,6BACI,gBAAiB,AACjB,eAAiB,CACpB,AACD,yBACA,+BACI,aAAe,CAClB,CACA","file":"ViewsModal.vue","sourcesContent":["\n.err[data-v-ab98fc2e] {\n  font-size: 16px;\n  padding: 15px;\n  padding-top: 0;\n}\n.modal[data-v-ab98fc2e] {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n}\n.modal-body[data-v-ab98fc2e] {\n    max-height: 80vh;\n    overflow-y: auto;\n}\n@media (min-width: 576px) {\n.modal-dialog[data-v-ab98fc2e] {\n    max-width: 70%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("7949df3c", content, true, {});

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.isEdit ? 'Edit' : 'Add') + " View")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.view.names), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "text",
        "value": item.name
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1)])
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.orderTypes), function(type) {
    return [(!_vm.selectedOrderTypes.includes(type) || _vm.view.orderTypes.includes(type)) ? _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "color": "primary",
        "value": type,
        "label": _vm.$lang.labels[type],
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.$emit('changeSelectedOrderTypes', type)
        }
      },
      model: {
        value: (_vm.view.orderTypes),
        callback: function($$v) {
          _vm.$set(_vm.view, "orderTypes", $$v)
        },
        expression: "view.orderTypes"
      }
    })], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": _vm.view.isDefault ? 'primary' : 'disabled'
    },
    on: {
      "click": function($event) {
        return _vm.$set(_vm.view, 'isDefault', !_vm.view.isDefault)
      }
    }
  }, [_c('v-icon', [_vm._v("bookmark")])], 1), _vm._v(" "), (_vm.languages.length > 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "outline": "",
      "type": "button"
    },
    slot: "activator"
  }, [_vm._v("\n          Add language\n          "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang, index) {
    return (lang !== _vm.language) ? _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addLang(lang.value, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(lang.text) + "\n            ")])], 1) : _vm._e()
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.e825bcc44cb0b37ee14a.js